module.exports = "//static.hsappstatic.net/LoginUI/static-1.15557/img/okta-logo.svg"